import { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import '../assets/styles/About.css';

function About() {
  const [businessForm, setBusinessForm] = useState({
    from: '',
    city: '',
    zip: '',
    to: '',
    toCity: '',
    toZip: '',
  });
  const [privateForm, setPrivateForm] = useState({
    from: '',
    city: '',
    zip: '',
    to: '',
    toCity: '',
    toZip: '',
  });
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const handleBusinessChange = (e) => {
    setBusinessForm({ ...businessForm, [e.target.name]: e.target.value });
  };

  const handlePrivateChange = (e) => {
    setPrivateForm({ ...privateForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e, formType) => {
    e.preventDefault();
    const formData = formType === 'business' ? businessForm : privateForm;

    // Validation
    if (Object.values(formData).some((value) => !value.trim())) {
      setAlert({
        show: true,
        type: 'danger',
        message: 'Please fill all fields',
      });
      setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000);
      return;
    }

    // EmailJS configuration
    const templateParams = {
      to_email: 'mhareed@rffcargo.co.ke',
      form_type: formType === 'business' ? 'Business' : 'Private Person',
      from: formData.from,
      city: formData.city,
      zip: formData.zip,
      to: formData.to,
      to_city: formData.toCity,
      to_zip: formData.toZip,
    };

    emailjs
      .send(
        'YOUR_SERVICE_ID', // Replace with your EmailJS Service ID
        'YOUR_TEMPLATE_ID', // Replace with your EmailJS Template ID
        templateParams,
        'YOUR_PUBLIC_KEY' // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          setAlert({
            show: true,
            type: 'success',
            message: 'Quote submitted successfully!',
          });
          // Clear form
          if (formType === 'business') {
            setBusinessForm({ from: '', city: '', zip: '', to: '', toCity: '', toZip: '' });
          } else {
            setPrivateForm({ from: '', city: '', zip: '', to: '', toCity: '', toZip: '' });
          }
          setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000);
        },
        (error) => {
          setAlert({
            show: true,
            type: 'danger',
            message: 'Failed to send quote. Please try again.',
          });
          console.error('EmailJS error:', error);
          setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000);
        }
      );
  };

  return (
    <section
      className="about-us-section py-5 position-relative"
      style={{
        backgroundImage: 'url(/assets/images/bg-4-1.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="overlay"></div>
      <div className="container position-relative">
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="about-title fw-bold mb-4">The Most Progressive Company</h2>
            <p className="main-description" style={{ color: '#ffffff' }}>
              RFF Cargo is a leading logistics provider, delivering innovative and reliable solutions for global freight and supply chain management.
            </p>
            <div className="row mt-4">
              <div className="col-6">
                <h3 className="h5 vision-mission-title">Vision</h3>
                <p className="vision-mission-text" style={{ color: '#ffffff' }}>
                  To be the trusted partner in logistics, driving efficiency and sustainability through cutting-edge technology and unparalleled service.
                </p>
                <Link to="/about" className="btn btn-read-more mt-2">
                  Read More
                </Link>
              </div>
              <div className="col-6">
                <h3 className="h5 vision-mission-title">Mission</h3>
                <p className="vision-mission-text" style={{ color: '#ffffff' }}>
                  We empower our clients with seamless, end-to-end logistics solutions, ensuring timely delivery and exceptional value across air, ocean, and land transport.
                </p>
                <Link to="/about" className="btn btn-read-more mt-2">
                  Read More
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12 mt-4 mt-md-0">
            <div className="quote-form p-4 bg-white rounded shadow" id="quote-form">
              <h3 className="quote-form-title h5 mb-3" style={{ color: '#333333' }}>
                Get a Shipment Quote
              </h3>
              {alert.show && (
                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                  {alert.message}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setAlert({ show: false, type: '', message: '' })}
                    aria-label="Close"
                  ></button>
                </div>
              )}
              <ul className="nav nav-tabs mb-3" id="quoteTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="business-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#business"
                    type="button"
                    role="tab"
                    aria-controls="business"
                    aria-selected="true"
                  >
                    Business
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="private-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#private"
                    type="button"
                    role="tab"
                    aria-controls="private"
                    aria-selected="false"
                  >
                    Private Person
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="quoteTabsContent">
                <div
                  className="tab-pane fade show active"
                  id="business"
                  role="tabpanel"
                  aria-labelledby="business-tab"
                >
                  <form onSubmit={(e) => handleSubmit(e, 'business')}>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="business-from" className="form-label">
                          From
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="business-from"
                          name="from"
                          value={businessForm.from}
                          onChange={handleBusinessChange}
                          placeholder="Enter origin"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="business-city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="business-city"
                          name="city"
                          value={businessForm.city}
                          onChange={handleBusinessChange}
                          placeholder="Enter city"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="business-zip" className="form-label">
                          Zip Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="business-zip"
                          name="zip"
                          value={businessForm.zip}
                          onChange={handleBusinessChange}
                          placeholder="Enter zip code"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="business-to" className="form-label">
                          To
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="business-to"
                          name="to"
                          value={businessForm.to}
                          onChange={handleBusinessChange}
                          placeholder="Enter destination"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="business-to-city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="business-to-city"
                          name="toCity"
                          value={businessForm.toCity}
                          onChange={handleBusinessChange}
                          placeholder="Enter city"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="business-to-zip" className="form-label">
                          Zip Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="business-to-zip"
                          name="toZip"
                          value={businessForm.toZip}
                          onChange={handleBusinessChange}
                          placeholder="Enter zip code"
                          required
                        />
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-submit-quote mt-3">
                          Submit Quote
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  className="tab-pane fade"
                  id="private"
                  role="tabpanel"
                  aria-labelledby="private-tab"
                >
                  <form onSubmit={(e) => handleSubmit(e, 'private')}>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="private-from" className="form-label">
                          From
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="private-from"
                          name="from"
                          value={privateForm.from}
                          onChange={handlePrivateChange}
                          placeholder="Enter origin"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="private-city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="private-city"
                          name="city"
                          value={privateForm.city}
                          onChange={handlePrivateChange}
                          placeholder="Enter city"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="private-zip" className="form-label">
                          Zip Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="private-zip"
                          name="zip"
                          value={privateForm.zip}
                          onChange={handlePrivateChange}
                          placeholder="Enter zip code"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="private-to" className="form-label">
                          To
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="private-to"
                          name="to"
                          value={privateForm.to}
                          onChange={handlePrivateChange}
                          placeholder="Enter destination"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="private-to-city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="private-to-city"
                          name="toCity"
                          value={privateForm.toCity}
                          onChange={handlePrivateChange}
                          placeholder="Enter city"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="private-to-zip" className="form-label">
                          Zip Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="private-to-zip"
                          name="toZip"
                          value={privateForm.toZip}
                          onChange={handlePrivateChange}
                          placeholder="Enter zip code"
                          required
                        />
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-submit-quote mt-3">
                          Submit Quote
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;